import { Stack } from '@mui/material'
import { LocationOn } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Address(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  const address = extOrder.atDepot
    ? extOrder.depot.name
    : extOrder.location.address || extOrder.location.geoAddress

  return (
    <preview.Field label={texts.address.label}>
      {address ? (
        <Stack direction="row" alignItems="center" spacing={1}>
          <LocationOn sx={{ fontSize: 20, color: t => t.vars.palette.action.active }} />
          <span>{address}</span>
        </Stack>
      ) : (
        <preview.NullValue />
      )}
    </preview.Field>
  )
}
